import { render, staticRenderFns } from "./OrganizationDomains.vue?vue&type=template&id=8c12f62c&"
import script from "./OrganizationDomains.vue?vue&type=script&lang=js&"
export * from "./OrganizationDomains.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDomains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports